import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AzzurroTable, SimpleButtonComponent, TitleContentComponent } from 'ngx-zcs-components';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IonicModule } from '@ionic/angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { ConfigurationsBlockComponent } from './configurations-block.component';
import { SettingsInverterComponent } from '../settings-inverter/settings-inverter.component';
import { UpgradeInverterComponent } from '../upgrade-inverter/upgrade-inverter.component';
import { BlockTitleComponent } from '../../lib/components/block-title/block-title.component';
import { HasModulePipe } from './has-module.pipe';


@NgModule({
  declarations: [
    ConfigurationsBlockComponent,
    HasModulePipe,
  ],
  imports: [
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    IonicModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    SettingsInverterComponent,
    SimpleButtonComponent,
    TitleContentComponent,
    TranslateModule,
    UpgradeInverterComponent,
  ],
  exports: [
    ConfigurationsBlockComponent,
  ],
})
export class ConfigurationsBlockModule {}
